import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import Swal from 'sweetalert2'
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
// Import removed - laravel-mix no longer available with Vite

class TransferDossier extends Component {
    constructor(props) {
        super();
        this.state = {
            step: 1,
            selectedOption: "option1",
            selectedUser: 0,
            providerUsers:[],
            isDisable:true,
            password:'',
            formData: {
                email:'',
                password:'',
                name:'',
            }
        };
    }

    getUsers = ()=>{
        axios.get('/api/users/by_provider/'+this.props.providerid).then(res=>{
            this.setState({ providerUsers:res.data})
        })
    }

    validateForm = ()=>{
        const fv = FormValidation.formValidation(KTUtil.getById('frm'+this.props.userid), {
            fields: {
                email: {
                    validators: {
                        notEmpty: {
                            message: 'Email requerido'
                        },
                        emailAddress: {
                            message: 'Email inválido'
                        }
                    },
                },
                name: {
                    validators: {
                        notEmpty: {
                            message: 'Nombre requerido'
                        }
                    },
                },

                email_confirmation: {
                    validators: {
                        notEmpty: {
                            message: 'Correo requerido'
                        },
                        identical: {
                            compare: function() {
                                return KTUtil.getById('email').value;
                            },
                            message: 'los correos deben coincidir'
                        }
                    }
                },
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                bootstrap: new FormValidation.plugins.Bootstrap({
                    eleInvalidClass: '',
                    eleValidClass: '',
                })
            },
        });

            const submitForm = document.getElementById('SubmitForm'+this.props.userid);
        submitForm.addEventListener('click', () => {
            fv.validate().then((status) => {
                if (status == 'Valid') {
                    this.setState(state => ({
                        step: state.step + 1
                    }));
                }
            })
        })
    }

    async componentDidMount() {
        this.getUsers();

    }
    handleOptionChange = event => {
        this.setState({ selectedOption: event.target.value },function(){
            if(event.target.value == 'option2'){
                this.validateForm()
                this.setState({ selectedUser: 0 });
                this.setState({ isDisable: false });
            }
        });
        this.setState({ isDisable: true });
    };

    handlePasswordChange = event => {
        this.setState({ password: event.target.value });
    }

    handleUserChange = event =>{
        this.setState({ selectedUser: event.target.value });
        this.setState({ isDisable: false });
    }

    goToNextStep = () => {
        if(this.state.selectedOption == 'option2'){
        }else{
            this.setState(state => ({
                step: state.step + 1
            }));
        }
    };

    goToPrevStep = () => {
        this.setState(state => ({
            step: state.step - 1
        }),function(){
            if(this.state.selectedOption == 'option2'){
                this.validateForm()
                this.setState({ isDisable: false });
            }
        });

        if(this.state.selectedUser != []){
            this.setState(this.setState({ isDisable: false }))
        }else{
            this.setState(this.setState({ isDisable: true }))
        }
    };

    handleConfirm = () => {
        let data = {
            email:this.state.formData.email,
            password:this.state.password,
            name:this.state.formData.name,
            providerId:this.props.providerid,
            selectedUser:this.state.selectedUser,
            userFrom:this.props.userid
        }
        window.blockUI();
        axios.post('/api/users/transfer_dossier/'+this.props.user,data).then(res=>{
            window.unblockUI();
            Swal.fire({
                html: getSuccessMessage(res),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            }).then(function(result) {
                location.reload()
            });
        }).catch(function (error) {
            window.unblockUI();
                Swal.fire({
                    html: getErrorsMessage(error),
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "Aceptar",
                    customClass: {
                        confirmButton: "btn font-weight-bold btn-primary"
                    }
                });
            });
    };

    handleFormDataChange = event => {
        this.setState({
            formData: { ...this.state.formData, [event.target.name]: event.target.value }
        });
    };

    render() {
        const { step, selectedOption, formData } = this.state;
        return (
            <>
                <div className="modal fade " id={'transferDossier'+this.props.userid} tabIndex="-1" role="dialog" aria-labelledby="exampleModalSizeSm" arian-hidden="true">
                    <div className="modal-dialog modal70 modal-dialog-centered modal-xl" role="document">
                        <div className="modal-content" style={{ background: 'rgb(237 237 237)' }}>
                            <div className="modal-body px-15 py-10">
                                <div className="text-dark font-weight-bold my-1   font-size-h4">Actualizar correo</div>
                                { this.state.step == 1  &&
                                <div className="text-muted mb-5 font-size-h5">Selecciona el usuario que sustituirá a  {this.props.emailfrom} .</div>
                                }
                                { this.state.step == 2  &&
                                <div className="text-muted mb-5 font-size-h5">Para finalizar, se requiere tu contraseña para autorizar el cambio.</div>
                                }
                                { this.state.step == 1  &&
                                    <div >
                                        <div className="row d-flex mb-5">
                                            <div className={ selectedOption == "option1" ? 'col-md-4  font-size-h5 selectedRadio'  : 'col-md-4 font-size-h5 text-dark'}>
                                                <input type="radio" value="option1" checked={selectedOption == "option1"} onChange={this.handleOptionChange}/> Usuarios Actuales
                                            </div>
                                            <div className={ selectedOption === "option2" ? 'col-md-4  font-size-h5 selectedRadio' : 'col-md-4 font-size-h5 text-dark '}>
                                                <input type="radio" name="option"  value="option2" checked={selectedOption === "option2"} onChange={this.handleOptionChange} /> Nuevo usuario
                                            </div>
                                        </div>
                                    {selectedOption === "option1" && (
                                        <div className="align-self-end  p-10 bg-white rounded border border-gray mb-10">
                                            <div className="text-dark-75 font-weight-bolder font-size-h5">Usuarios actuales de {this.props.providerfiscalname} </div>
                                            <span className="text-dark-50 font-weight-bold font-size-h5">{this.state.providerUsers.length - 1} usuarios disponibles</span>
                                            <div className="d-flex flex-column font-size-h5 mt-5 users-people-container">
                                            {
                                            this.state.providerUsers.length === 0 ?
                                                <div>Esta empresa no tiene usuarios disponibles</div> :
                                                <table className="table table-borderless">
                                                <tbody>
                                                    {this.state.providerUsers.map((u, index) => {
                                                    if (u.user.id != this.props.userid) {
                                                        return (
                                                        <tr key={index}>
                                                            <td className="d-flex gap-1">
                                                            <input type="radio"
                                                                checked={this.state.selectedUser === u.user.id.toString()}
                                                                value={u.user.id} name="user"
                                                                onChange={this.handleUserChange} />
                                                            <b>{u.user.name}</b>
                                                            </td>
                                                            <td className="text-muted font-size-sm">{u.user.email}</td>
                                                        </tr>
                                                        );
                                                    }
                                                    })}
                                                </tbody>
                                                </table>
                                            }
                                        </div>
                                    </div>
                                    )}
                                    {selectedOption === "option2" && (
                                    <div className="align-self-end  p-10 bg-white rounded border border-gray mb-10">
                                        <form id={'frm'+this.props.userid} >
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="name">Nombre</label>
                                                        <input
                                                        type="text"
                                                        className="form-control"
                                                        id="name"
                                                        name="name"
                                                        value={formData.name}
                                                        onChange={this.handleFormDataChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="email">Correo Electrónico</label>
                                                        <input
                                                        type="email"
                                                        className="form-control"
                                                        id="email"
                                                        name="email"
                                                        value={formData.email}
                                                        onChange={this.handleFormDataChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="email">Confirmar correo electrónico</label>
                                                        <input
                                                        name="email_confirmation"
                                                        autoComplete="false"
                                                        id="email_confirmation"
                                                        type="text"
                                                        className="form-control"
                                                        required
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    )}
                                    <div className="d-flex justify-content-end">
                                    <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-dismiss="modal"
                                    >
                                    Cancelar
                                    </button>
                                    <button type="button" id={'SubmitForm'+this.props.userid}  className="btn btn-primary" onClick={this.goToNextStep}
                                    disabled={this.state.isDisable}
                                    >
                                    Siguiente
                                    </button>
                                    </div>
                                    </div>
                                }
                                { this.state.step == 2  &&
                                <>
                                <div  className="align-self-end  p-10 bg-white rounded border border-gray mb-10">
                                    <h5>Confirmar actualización</h5>
                                    <div className="navi-link d-flex">
                                        <div className="symbol symbol-40 bg-light mr-3">
                                            <div className="symbol-label">
                                                <span className="flaticon-avatar icon-md text-primary"></span>
                                            </div>
                                        </div>
                                        <div className="navi-text">
                                            <div className="font-weight-bold">{this.props.namefrom}</div>
                                            <div className="text-muted">{this.props.emailfrom}</div>
                                        </div>
                                    </div>
                                    <input className="form-control mt-5" type="password" value={this.state.password}
                                    onChange={this.handlePasswordChange}/>
                                </div>
                                <div className="d-flex justify-content-end mt-5">
                                    <button type="button" className="btn btn-secondary" onClick={this.goToPrevStep}>
                                        Cancelar
                                    </button>
                                    <button type="button" className="btn btn-primary" onClick={this.handleConfirm}>
                                        Transferir
                                    </button>
                                </div>
                                </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default TransferDossier;

if (document.getElementById('TransferDossier')) {
    ReactDOM.render(<TransferDossier />, document.getElementById('TransferDossierw'));
}
